import React from 'react';
import { Helmet } from 'react-helmet-async';
interface PageTitleProps {
  title?: string;
  description?: string;
  canonical?: string;
  image?: string;
  keywords?: string;
  author?: string;
}
export function PageTitle({
  title,
  description,
  canonical,
  image,
  keywords,
  author
}: PageTitleProps) {
  const siteName = 'Katalina Bock Product Leadership Portfolio';
  const defaultDescription = 'Product leader specializing in product strategy, growth, and innovation with impact across Fortune 50, unicorn, and startup companies.';
  const defaultImage = 'https://uploadthingy.s3.us-west-1.amazonaws.com/katalina-profile-image.jpg';
  const defaultKeywords = 'product management, product leader, product strategy, growth, innovation, Fortune 50, unicorn, marketing, leadership, startup';
  const defaultAuthor = 'Katalina Bock';
  const pageTitle = title ? `${title} | ${siteName}` : siteName;
  const metaDescription = description || defaultDescription;
  const metaImage = image || defaultImage;
  const metaKeywords = keywords || defaultKeywords;
  const metaAuthor = author || defaultAuthor;
  const siteUrl = 'https://katalinabock.com';
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;
  return <Helmet data-id="element-120">
      {/* Basic Meta Tags */}
      <title data-id="element-121">{pageTitle}</title>
      <meta name="description" content={metaDescription} data-id="element-122" />
      <meta name="keywords" content={metaKeywords} data-id="element-123" />
      <meta name="author" content={metaAuthor} data-id="element-124" />
      <link rel="canonical" href={canonicalUrl} data-id="element-125" />
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" data-id="element-126" />
      <meta property="og:url" content={canonicalUrl} data-id="element-127" />
      <meta property="og:title" content={pageTitle} data-id="element-128" />
      <meta property="og:description" content={metaDescription} data-id="element-129" />
      <meta property="og:image" content={metaImage} data-id="element-130" />
      <meta property="og:site_name" content={siteName} data-id="element-131" />
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-id="element-132" />
      <meta property="twitter:url" content={canonicalUrl} data-id="element-133" />
      <meta property="twitter:title" content={pageTitle} data-id="element-134" />
      <meta property="twitter:description" content={metaDescription} data-id="element-135" />
      <meta property="twitter:image" content={metaImage} data-id="element-136" />
    </Helmet>;
}